import React, { FC, MouseEvent, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { useSnackbar } from "notistack";
import { AllocatorService } from "src/services";
import { ALLOCATOR_SEARCH_PARAMS, AllocatorReportExportOption, FixMeLater } from "src/types";
import { useAppSelector } from "src/hooks";
import { StyledContainedButton } from "src/products/Allocator/Allocator.styled";
import { downloadFile } from "src/utils";

const ReportExportButton: FC = () => {
    const allocatorService = AllocatorService.getInstance();

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [searchParams] = useSearchParams();
    const jobId = searchParams.get(ALLOCATOR_SEARCH_PARAMS.JOB_ID);
    const product: FixMeLater = useAppSelector((state) => state?.Product?.value);
    const exportOptions: AllocatorReportExportOption[] = useAppSelector(
        (state) => state?.[product?.productName]?.value?.exportOptions
    );

    const { enqueueSnackbar } = useSnackbar();

    const handleClickOpen = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event?.currentTarget);
    };

    const handleCloseMenu = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(null);
    };

    const handleExportReport = async (event: MouseEvent<HTMLElement>) => {
        handleCloseMenu(event);
        try {
            const reportDownloadable = await allocatorService.generateImpReport(
                String(event?.currentTarget?.dataset?.name),
                {
                    jobId: Number(jobId),
                },
            );
            const { blob, contentDispositionHeader } = reportDownloadable;
            downloadFile(blob, contentDispositionHeader.split("filename=")[1]);
            enqueueSnackbar("Exported successfully", { variant: "success" });
        } catch (error) {
            enqueueSnackbar("Failed to download report", { variant: "error" });
        }
    };

    return (
        <>
            <StyledContainedButton
                sx={{marginRight: "24px"}}
                variant="contained"
                onClick={handleClickOpen}
            >
                Export .imp
            </StyledContainedButton>
            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={handleCloseMenu}
                onContextMenu={handleCloseMenu}
            >
                {exportOptions?.map(
                    (option: AllocatorReportExportOption, index: number) => {
                        return (
                            <MenuItem
                                key={index}
                                onClick={handleExportReport}
                                data-name={option.name}
                            >
                                {option.displayName}
                            </MenuItem>
                        );
                    }
                )}
            </Menu>
        </>
    );
};

export default ReportExportButton;
